import React from 'react';
import { useTranslation } from 'react-i18next';
import { StepHeader, WizField, WizTextarea } from '../wizardUi';

export default function Step5BusinessPolicies({ wizard }) {
  const { t } = useTranslation();
  const { policies, setPoliciesField } = wizard;

  return (
    <div className="flex flex-col gap-5 lg:mx-auto lg:max-w-2xl lg:gap-6">
      <StepHeader eyebrow={t('wizardIg.eyebrow', { n: 5 })} title={t('wizardIg.titlePolicies')} sub={t('wizardIg.subPolicies')} />

      <WizField label={t('wizardIg.labelPolicies')}>
        <WizTextarea
          rows={8}
          value={policies.text}
          onChange={(e) => setPoliciesField('text', e.target.value)}
          placeholder={t('wizardIg.phPolicies')}
          className="lg:min-h-[220px]"
        />
      </WizField>

      <p className="text-[12.5px] leading-relaxed text-white/45">{t('wizardIg.policiesExamplesNote')}</p>
    </div>
  );
}
